import { useState } from "react";
export const useType = (initialValue) => {
    const [state, setState] = useState(initialValue);
    const setPartial = (values) => setState(current => (Object.assign(Object.assign({}, current), values)));
    return [state, setPartial, setState];
};
